/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';

import TakePhotoFromCamera from 'apps/web_forms/components/TakePhotoFromCamera';
import SignaturePadContainer from 'apps/web_forms/components/commons/SignaturePad/SignaturePadContainer';
import BarcodeCropper from 'apps/web_forms/components/commons/BarcodeCropper';
import ResourcePreview from 'apps/web_forms/components/ResourcePreview';
import FormMap from './FormMap';
import useGlobalSelector from 'apps/web_forms/hooks/useGlobalSelector';

const MultimediaElements = () => {
  const { currentSelectedMultimediaInput, isOpen } = useGlobalSelector();

  const { element = {}, additionalProps = {} } = currentSelectedMultimediaInput;

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, []);

  const getMultimediaElement = () => {
    switch (element.type) {
      case 'location':
        return <FormMap element={element} />;
      case 'image':
        return <TakePhotoFromCamera element={element} />;
      case 'barcode':
        if (additionalProps.uploadedImageSrc) {
          return <BarcodeCropper element={element} {...additionalProps} />;
        }

        return <TakePhotoFromCamera element={element} scanBarcode />;
      case 'license':
        if (additionalProps.uploadedImageSrc) {
          return <BarcodeCropper element={element} {...additionalProps} />;
        }
        return <TakePhotoFromCamera element={element} scanBarcode />;
      case 'signature':
      case 'sketch':
        return <SignaturePadContainer element={element} />;
      case 'resource':
        return <ResourcePreview element={element} />;
      default:
        return null;
    }
  };

  return (
    <>
      {element && !loading && getMultimediaElement()}
      {element && loading && <></>}
    </>
  );
};

export default MultimediaElements;
